import { Clock } from '@/utils/Clock.js'

export class Raf {
  static init() {
    this.frames = []
    this.time = new Clock()
    this.render = (t) => this.frame(t)
  }

  static start() {
    this.stopped = false
    this.time.start()
    this.id = window.requestAnimationFrame(this.render)
  }

  static stop(force = false) {
    if (force) {
      window.cancelAnimationFrame(this.id)
    }

    this.time.stop()
    this.stopped = true
  }

  static frame(t) {
    const delta = this.time.getDelta()
    const time = this.time.getElapsedTime()

    // Get the distance between this execution and the last
    if (this.frames.length < 1) return false

    for (let index = 0; index < this.frames.length && this.frames.length > 0; index++) {
      if (this.frames.length) this.frames[index].handler({ time, delta, frame: t })
    }

    // Continus the loop if not already stopped
    if (!this.stopped) {
      this.id = window.requestAnimationFrame(this.render)
    }
  }

  static add(handler, id) {
    if (typeof handler !== 'function') throw new Error('Expected function as handler')
    if (typeof id === 'undefined') id = `h_${++this.uidCounter}`
    this.frames.push({
      id,
      handler,
    })
    if (this.frames.length === 1) this.start()
    return id
  }

  static moveToFirst(id) {
    if (typeof id === 'undefined') throw new Error('Expected id')
    const index = this.frames.findIndex((object) => object.id === id)
    if (index < 0) return
    else this.frames.unshift(this.frames.splice(index, 1)[0])
  }

  static moveToLast(id) {
    if (typeof id === 'undefined') throw new Error('Expected id')
    const index = this.frames.findIndex((object) => object.id === id)
    if (index < 0) return
    else this.frames.push(this.frames.splice(index, 1)[0])
  }

  static remove(id) {
    if (typeof id === 'undefined') throw new Error('Expected id')
    const index = this.frames.findIndex((object) => object.id === id)
    if (index < 0) return
    else this.frames.splice(index, 1)
    if (this.frames.length <= 0) this.stop()
  }
}
